import React, { useState, useRef,useEffect } from "react";
import axios from "axios";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { FaLocationArrow } from "react-icons/fa";
import CoordinateMap from "./questionnaire/CoordinateMap";
const EditModal = ({ 
  isOpen, 
  toggle, 
  selectedItem, 
  setSelectedItem, 
  onSave 
}) => {
  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [isPreviewing, setIsPreviewing] = useState(false);
  const [fotoRumah, setFotoRumah] = useState(null);
  const videoRef = useRef(null);
  const [isBacklog, setIsBacklog] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
     const [errorMessage, setErrorMessage] = useState("");
      const [desaOptions, setDesaOptions] = useState([]);
      useEffect(() => {
    if (isOpen) {
      // Saat modal dibuka, reset state foto jika tidak ada foto sebelumnya
      if (!selectedItem?.fotos || selectedItem.fotos.length === 0) {
        setImagePreview(null);
        setFotoRumah(null);
      } else {
        // Jika ada foto existing, tampilkan preview
        setImagePreview(selectedItem.fotos[0]?.url || null);
        setFotoRumah(null); // Reset file baru
      }
    } else {
      // Saat modal ditutup, bersihkan semua state
      cleanupCamera();
      setImagePreview(null);
      setFotoRumah(null);
      setIsPreviewing(false);
    }
  }, [isOpen, selectedItem]);
 useEffect(() => {
    // const kecamatanDesa = {
    //   Taliwang: ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
    //   Seteluk: ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
    //   PotoTano: ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
    //   BrangRea: ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
    //   BrangEne: ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
    //   Jereweh: ["Dasan Anyar", "Goa", "Beru", "Belo"],
    //   Maluk: ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
    //   Sekongkang: ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
    // };
    const kecamatanDesa = {
      "Taliwang": ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
      "Seteluk": ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
      "Poto Tano": ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
      "Brang Rea": ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
      "Brang Ene": ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
      "Jereweh": ["Dasan Anyar", "Goa", "Beru", "Belo"],
      "Maluk": ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
      "Sekongkang": ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
    };

    if (selectedItem && selectedItem.kecamatan) {
    //  setDesaOptions(kecamatanDesa[selectedItem.kecamatan.replace(/\s/g, "")] || []);
    setDesaOptions(kecamatanDesa[selectedItem.kecamatan] || []);
    } else {
      setDesaOptions([]);
    }
  }, [selectedItem]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setSelectedItem((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: value,
        ...(name === "manualTitikKoordinatRumah" ? { titikKoordinatRumah: "" } : {}),
        ...(name === "titikKoordinatRumah" ? { manualTitikKoordinatRumah: "" } : {})
      };
      if (name === "jumlahKK" && parseInt(value) > 1) {
        setIsBacklog(true);
      } else if (name === "jumlahKK" && parseInt(value) <= 1) {
        setIsBacklog(false);
      }
      if (name === "kepemilikanKamarMandiDanJamban" && value === "Tidak Ada") {
        updatedData = {
          ...updatedData,
          jumlahJamban: 0,
          jenisKloset: "Tidak Ada",
          jenisTangkiSeptik: "Tidak Ada",
          materialTangkiSeptik: "Tidak Ada",
          alasTangkiSeptik: "Tidak Ada",
          lubangPenyedotan: "Tidak Ada",
          posisiTangkiSeptik: "Tidak Ada",
          jarakTangkiSeptikDenganSumberAir: "Tidak Ada",
        };
      }
      if (name === "statusrumah" && value === "Tidak Berpenghuni") {
        updatedData = {
          ...updatedData,
          tanggallahir: null,
          jenisKelamin: "Kosong",
          nomorKK: "0000000000000000",
          nomorKTP: "0000000000000000",
          asalKTP: "0",
          jumlahKK: "0",
          jumlahPenghuni: "0",
          pendidikanTerakhir: "0",
          pekerjaan: "0",
          penghasilan: "0",
          statusKepemilikanRumah: "0",
          asetRumahDiTempatLain: "0",
          statusKepemilikanTanah: "0",
          asetTanahDiTempatLain: "0",
          sumberPenerangan: "0",
          dayaListrik: "0",
          bantuanPerumahan: "0",
          buanganAirLimbahRumahTangga: "0",
          saranaPengelolaanLimbahCair: "0",
          pemiliharaanSaranaPengelolaanLimbah: "0",
          jenisTempatPembuanganAirTinja: "0",
          kepemilikanKamarMandiDanJamban: "0",
          jumlahJamban: "0",
          jenisKloset: "0",
          jenisTangkiSeptik: "0",
          materialTangkiSeptik: "0",
          alasTangkiSeptik: "0",
          lubangPenyedotan: "0",
          posisiTangkiSeptik: "0",
          jarakTangkiSeptikDenganSumberAir: "0",
          sumberAirMinum: "0",
        };
      }
  
      return updatedData;
    });
  };
    const cleanupCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const startPreview = async () => {
    setIsPreviewing(true);
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" }, 
    });
    videoRef.current.srcObject = stream;
    await videoRef.current.play();
  };
  
  const handleGetCoordinates = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setSelectedItem((prevData) => ({
            ...prevData,
            titikKoordinatRumah: `${latitude}, ${longitude}`,
            manualTitikKoordinatRumah: "",
          }));
        },
        (error) => {
          setErrorMessage("Error getting coordinates: " + error.message);
          setModalOpen(true); 
        }
      );
    } else {
      setErrorMessage("Geolocation is not supported by this browser.");
      setModalOpen(true); 
    }
  };

  // Handler for when user drags marker on the map
  const handleMapCoordinateChange = (coordString) => {
    setSelectedItem((prevData) => ({
      ...prevData,
      manualTitikKoordinatRumah: coordString,
      titikKoordinatRumah: "",
    }));
  };

  const capturePhoto = async () => {
    const canvas = document.createElement("canvas");
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    canvas.getContext("2d").drawImage(videoRef.current, 0, 0);
  
    const dataUrl = canvas.toDataURL("image/png");
    const blob = await fetch(dataUrl).then((res) => res.blob());
    setFotoRumah(new File([blob], "captured-photo.png", { type: "image/png" }));
    setImagePreview(dataUrl);
  
    videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    setIsPreviewing(false);
  };

  const cancelPreview = () => {
    setImagePreview(null);
    setFotoRumah(null);
    if (isPreviewing) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    }
    cleanupCamera();
    setIsPreviewing(false);
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
        setFotoRumah(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFormSubmit = async () => {
    try {
      if (fotoRumah) {
        const formData = new FormData();
        Object.keys(selectedItem).forEach(key => {
          if (key !== 'Admin' && key !== 'fotos' && selectedItem[key] !== null) {
            formData.append(key, selectedItem[key]);
          }
        });
        if (fotoRumah instanceof File) {
          formData.append('files', fotoRumah);
        } else {
          const blob = await fetch(fotoRumah).then(r => r.blob());
          formData.append('files', blob, 'camera_photo.jpg');
        }
        
        onSave(formData, true);
      } else {
        const dataToSend = { ...selectedItem };
        delete dataToSend.Admin;
        delete dataToSend.fotos;
        
        onSave(dataToSend, false);
      }
    } catch (error) {
      console.error("Error in form submission:", error);
    }
  };
  
  useEffect(() => {
    return () => {
      cleanupCamera();
    };
  }, []);


  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ paddingTop: "40px" }}>
      <ModalHeader toggle={toggle} className="custom-modal-header">
        Edit Data
      </ModalHeader>
      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <FormGroup>
          <Label for="statusrumah">Status Rumah</Label>
          <Input 
            type="select" 
            name="statusrumah" 
            id="statusrumah" 
            value={selectedItem?.statusrumah || ""} 
            onChange={handleInputChange}
          >
            <option value="">Pilih</option>
            <option value="Tidak Berpenghuni">Tidak Berpenghuni</option>
            <option value="Berpenghuni">Berpenghuni</option>
          </Input>
          {errors.statusrumah && <div className="error-message">{errors.statusrumah}</div>}
        </FormGroup>
        
      <FormGroup>
                                <Label for="nomorUrut">1. Nomor Blok</Label>
                                <Input type="number" name="nomorUrut" id="nomorUrut" value={selectedItem?.nomorUrut || ""} onChange={handleInputChange} />
                              </FormGroup>
                    
                              <FormGroup>
                                <Label for="nomorRumahPadaPeta">2. Nomor Peta</Label>
                                <Input type="number" name="nomorRumahPadaPeta" id="nomorRumahPadaPeta" value={selectedItem?.nomorRumahPadaPeta || ""} onChange={handleInputChange} />
                              </FormGroup>
                              <FormGroup>
                                <Label for="namaLengkapKK">3. Nama Lengkap KK</Label>
                                <Input type="text" name="namaLengkapKK" value={selectedItem?.namaLengkapKK || ""} onChange={handleInputChange} />
                              </FormGroup>
                            <Label for="tanggallahir">4. Tanggal lahir</Label>
                                <Input
                                    type="date"
                                    name="tanggallahir"
                                    id="tanggallahir"
                                    value={selectedItem?.tanggallahir}
                                    onChange={handleInputChange}
                                    disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}
                                    className="input-center"
                                    placeholder="DD/MM/YYYY"
                                />
                                {errors.tanggallahir && (
                                    <div className="error-message">{errors.tanggallahir}</div>
                                )}
                              <FormGroup>
                                <Label for="jenisKelamin">5. Jenis Kelamin</Label>
                                <Input type="select" name="jenisKelamin" id="jenisKelamin" value={selectedItem?.jenisKelamin || ""} onChange={handleInputChange}
                                disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                  <option value="">Pilih</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </Input>
                              </FormGroup>
                              <FormGroup>
                                  <Label for="nomorKK">6. Nomor KK</Label>
                                  <Input type="text" name="nomorKK" id="nomorKK" value={selectedItem?.nomorKK || ""} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} />
                                  {errors.nomorKK && <div className="invalid-feedback">{errors.nomorKK}</div>}
                                </FormGroup>
                              {/* Continue adding the rest of your additional form fields in a similar manner */}
                            
                            <FormGroup>
                                  <Label for="nomorKTP">7. Nomor KTP</Label>
                                  <Input type="text" name="nomorKTP" id="nomorKTP" value={selectedItem?.nomorKTP || ""} onChange={handleInputChange} className={`input-center ${errors.nomorKTP ? "is-invalid" : ""}`}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} />
                                  {errors.nomorKTP && <div className="invalid-feedback">{errors.nomorKTP}</div>}
                                </FormGroup>
                                <FormGroup>
                                  <Label for="asalKTP">8. Asal KTP</Label>
                                  <Input type="select" name="asalKTP" id="asalKTP" value={selectedItem?.asalKTP} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="KSB">KSB</option>
                                    <option value="Luar KSB">Luar KSB</option>
                                  </Input>
                                  {errors.asalKTP && <div className="error-message">{errors.asalKTP}</div>}
                                </FormGroup>
                                {/* <FormGroup>
                                  <Label for="jumlahKK">9. Jumlah KK Dalam Rumah</Label>
                                  <Input type="number" name="jumlahKK" id="jumlahKK" value={selectedItem?.jumlahKK || ""} onChange={handleInputChange} className="input-center" />
                                  {errors.jumlahKK && <div className="error-message">{errors.jumlahKK}</div>}
                                </FormGroup> */}
                                <FormGroup>
                                  <Label for="jumlahKK">9. Jumlah KK Dalam Rumah</Label>
                                  <Input
                                    type="number"
                                    name="jumlahKK"
                                    id="jumlahKK"
                                    value={selectedItem?.jumlahKK || ""}
                                    onChange={handleInputChange}
                                    disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}
                                    className="input-center"
                                  />
                                  {errors.jumlahKK && <div className="error-message">{errors.jumlahKK}</div>}
                    
                                  {/* Conditionally render "Backlog" message if jumlahKK is more than 1 */}
                                  {isBacklog && (
                                    <div className="info-message">
                                      Rumah ini dianggap "Backlog" karena terdapat lebih dari 1 KK.
                                    </div>
                                  )}
                                </FormGroup>
                                  
                    
                                <FormGroup>
                                  <Label for="jumlahPenghuni">10. Jumlah Penghuni</Label>
                                  <Input type="number" name="jumlahPenghuni" id="jumlahPenghuni" value={selectedItem?.jumlahPenghuni || ""} onChange={handleInputChange} className="input-center"
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} />
                                  {errors.jumlahPenghuni && <div className="error-message">{errors.jumlahPenghuni}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="alamatRumah">11. Alamat Rumah (RT/RW/Dusun/Lingkungan)</Label>
                                  <Input type="text" name="alamatRumah" id="alamatRumah" value={selectedItem?.alamatRumah} onChange={handleInputChange} className="input-center" />
                                  {errors.alamatRumah && <div className="error-message">{errors.alamatRumah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="kecamatan">12. Kecamatan</Label>
                                  <Input type="select" name="kecamatan" id="kecamatan" value={selectedItem?.kecamatan} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Taliwang">Taliwang</option>
                                    <option value="Seteluk">Seteluk</option>
                                    <option value="Poto Tano">Poto Tano</option>
                                    <option value="Brang Rea">Brang Rea</option>
                                    <option value="Brang Ene">Brang Ene</option>
                                    <option value="Jereweh">Jereweh</option>
                                    <option value="Maluk">Maluk</option>
                                    <option value="Sekongkang">Sekongkang</option>
                                  </Input>
                                  {errors.kecamatan && <div className="error-message">{errors.kecamatan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="desaKelurahan">13. Desa/Kelurahan</Label>
                                  <Input type="select" name="desaKelurahan" id="desaKelurahan" value={selectedItem?.desaKelurahan} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    {desaOptions.map((desa, index) => (
                                      <option key={index} value={desa}>
                                        {desa}
                                      </option>
                                    ))}
                                  </Input>
                                  {errors.desaKelurahan && <div className="error-message">{errors.desaKelurahan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="pendidikanTerakhir">14. Pendidikan Terakhir</Label>
                                  <Input type="select" name="pendidikanTerakhir" id="pendidikanTerakhir" value={selectedItem?.pendidikanTerakhir} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Tidak Punya Ijazah">Tidak Punya Ijazah</option>
                                    <option value="SD/Sederajat">SD/Sederajat</option>
                                    <option value="SMP/Sederajat">SMP/Sederajat</option>
                                    <option value="SMA/Sederajat">SMA/Sederajat</option>
                                    <option value="D1">D1</option>
                                    <option value="D2">D2</option>
                                    <option value="D3">D3</option>
                                    <option value="D4/S1">D4/S1</option>
                                    <option value="S2">S2</option>
                                    <option value="S3">S3</option>
                                  </Input>
                                  {errors.pendidikanTerakhir && <div className="error-message">{errors.pendidikanTerakhir}</div>}
                                </FormGroup>
                    
                                <FormGroup>
  <Label for="pekerjaan">15. Pekerjaan</Label>
  
  <div className="d-flex mb-2">
            <Input
              type="select"
              name="pekerjaanType"
              id="pekerjaanType"
              value={selectedItem?.pekerjaanType || ""}
              onChange={(e) => {
                const isManual = e.target.value === "manual";
                setSelectedItem(prev => ({
                  ...prev,
                  pekerjaanType: e.target.value,
                  pekerjaan: isManual ? "" : prev.pekerjaan
                }));
              }}
              disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}
              style={{ width: "150px", marginRight: "10px" }}
            >
              <option value="">Pilih Tipe</option>
              <option value="predefined">Pilih Dari Daftar</option>
              <option value="manual">Input Manual</option>
            </Input>

            {selectedItem?.pekerjaanType === "manual" ? (
              <Input
                type="text"
                name="pekerjaan"
                id="pekerjaan"
                value={selectedItem?.pekerjaan || ""}
                onChange={handleInputChange}
                disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}
              />
            ) : (
              <Input
                type="select"
                name="pekerjaan"
                id="pekerjaan"
                value={selectedItem?.pekerjaan || ""}
                onChange={handleInputChange}
                disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}
              >
                <option value="">Pilih</option>
                <option value="Tidak Bekerja">Tidak Bekerja</option>
                <option value="Pensiunan">Pensiunan</option>
                <option value="Karyawan BUMN">Karyawan BUMN</option>
                <option value="Wirausaha">Wirausaha</option>
                <option value="Petani/Pekebun">Petani/Pekebun</option>
                <option value="Nelayan">Nelayan</option>
                <option value="Pedagang">Pedagang</option>
                <option value="Karyawan Swasta">Karyawan Swasta</option>
                <option value="Tukang/Montir">Tukang/Montir</option>
                <option value="Buruh Harian">Buruh Harian</option>
                <option value="Honorer">Honorer</option>
                <option value="TNI/POLRI">TNI/POLRI</option>
                <option value="ASN">ASN</option>
                <option value="Kepala Desa">Kepala Desa</option>
                <option value="Perangkat Desa/Kelurahan">Perangkat Desa/Kelurahan</option>
                <option value="BPD">BPD</option>
                <option value="DPRD">DPRD</option>
                <option value="Bupati">Bupati</option>
                <option value="Wakil Bupati">Wakil Bupati</option>
              </Input>
            )}
          </div>

          {errors.pekerjaan && <div className="error-message">{errors.pekerjaan}</div>}
        </FormGroup>

                    
                                <FormGroup>
                                  <Label for="fungsiBangunan">16. Fungsi Bangunan</Label>
                                  <Input type="select" name="fungsiBangunan" id="fungsiBangunan" value={selectedItem?.fungsiBangunan} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Rumah Tinggal/Hunian">Rumah Tinggal/Hunian</option>
                                    <option value="Rumah Toko (RUKO)">Rumah Toko (RUKO)</option>
                                  </Input>
                                  {errors.fungsiBangunan && <div className="error-message">{errors.fungsiBangunan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
  <Label for="penghasilan">17. Penghasilan/Bulan</Label>
  <div className="d-flex mb-2">
                            <Input 
                              type="select" 
                              name="penghasilanType" 
                              id="penghasilanType" 
                              value={selectedItem?.penghasilanType || "predefined"}
                              disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} 
                              onChange={(e) => {
                                const isManual = e.target.value === "manual";
                                setSelectedItem(prev => ({
                                  ...prev,
                                  penghasilanType: e.target.value,
                                  penghasilan: isManual ? "" : prev.penghasilan
                                }));
                              }}
                              style={{ width: "150px", marginRight: "10px" }}
                            >
                              <option value="predefined">Pilih Nominal</option>
                              <option value="manual">Input Manual</option>
                            </Input>
                          </div>

                          {(selectedItem?.penghasilanType === "predefined" || !selectedItem?.penghasilanType) && (
                            <Input 
                              type="select" 
                              name="penghasilan" 
                              id="penghasilan" 
                              value={selectedItem?.penghasilan || ""}
                              disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} 
                              onChange={handleInputChange}
                            >
                              <option value="">Pilih</option>
                              <option value="4300000">Rp. 4.300.000</option>
                              <option value="4000000">Rp. 4.000.000</option>
                              <option value="3700000">Rp. 3.700.000</option>
                              <option value="3400000">Rp. 3.400.000</option>
                              <option value="3100000">Rp. 3.100.000</option>
                              <option value="2800000">Rp. 2.800.000</option>
                              <option value="2500000">Rp. 2.500.000</option>
                              <option value="2200000">Rp. 2.200.000</option>
                              <option value="1800000">Rp. 1.800.000</option>
                              <option value="1500000">Rp. 1.500.000</option>
                              <option value="1200000">Rp. 1.200.000</option>
                              <option value="1000000">Rp. 1.000.000</option>
                              <option value="900000">Rp. 900.000</option>
                              <option value="600000">Rp. 600.000</option>
                              <option value="0">Rp. 0</option>
                            </Input>
                          )}

                          {selectedItem?.penghasilanType === "manual" && (
                            <Input 
                              type="number" 
                              name="penghasilan" 
                              id="penghasilanManual" 
                              placeholder="Masukkan penghasilan per bulan" 
                              value={selectedItem?.penghasilan || ""}
                              disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} 
                              onChange={handleInputChange}
                            />
                          )}
                          
                          {errors.penghasilan && <div className="error-message">{errors.penghasilan}</div>}
                        </FormGroup>
                                <FormGroup>
                                  <Label for="statusKepemilikanRumah">18. Status Kepemilikan Rumah</Label>
                                  <Input type="select" name="statusKepemilikanRumah" id="statusKepemilikanRumah" value={selectedItem?.statusKepemilikanRumah} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Milik Sendiri">Milik Sendiri</option>
                                    <option value="Bukan Milik Sendiri">Bukan Milik Sendiri</option>
                                    <option value="Kontrak/Sewa">Kontrak/Sewa</option>
                                  </Input>
                                  {errors.statusKepemilikanRumah && <div className="error-message">{errors.statusKepemilikanRumah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="asetRumahDiTempatLain">19. Aset Rumah di Tempat lain</Label>
                                  <Input type="select" name="asetRumahDiTempatLain" id="asetRumahDiTempatLain" value={selectedItem?.asetRumahDiTempatLain} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Ada">Ada</option>
                                    <option value="Tidak Ada">Tidak Ada</option>
                                  </Input>
                                  {errors.asetRumahDiTempatLain && <div className="error-message">{errors.asetRumahDiTempatLain}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="statusKepemilikanTanah">20. Status Kepemilikan Tanah</Label>
                                  <Input type="select" name="statusKepemilikanTanah" id="statusKepemilikanTanah" value={selectedItem?.statusKepemilikanTanah} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Milik Sendiri">Milik Sendiri</option>
                                    <option value="Bukan Milik Sendiri">Bukan Milik Sendiri</option>
                                    <option value="Tanah Negara">Tanah Negara</option>
                                  </Input>
                                  {errors.statusKepemilikanTanah && <div className="error-message">{errors.statusKepemilikanTanah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="asetTanahDiTempatLain">21. Aset Tanah di Tempat Lain</Label>
                                  <Input type="select" name="asetTanahDiTempatLain" id="asetTanahDiTempatLain" value={selectedItem?.asetTanahDiTempatLain} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Ada">Ada</option>
                                    <option value="Tidak Ada">Tidak Ada</option>
                                  </Input>
                                  {errors.asetTanahDiTempatLain && <div className="error-message">{errors.asetTanahDiTempatLain}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="sumberPenerangan">22. Sumber Penerangan</Label>
                                  <Input type="select" name="sumberPenerangan" id="sumberPenerangan" value={selectedItem?.sumberPenerangan} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="PLN dengan Meteran">PLN dengan Meteran</option>
                                    <option value="PLN tanpa Meteran">PLN tanpa Meteran</option>
                                    <option value="Listrik Non PLN">Listrik Non PLN</option>
                                    <option value="Bukan Listrik">Bukan Listrik</option>
                                  </Input>
                                  {errors.sumberPenerangan && <div className="error-message">{errors.sumberPenerangan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="dayaListrik">23. Daya Listrik</Label>
                                  <Input type="select" name="dayaListrik" id="dayaListrik" value={selectedItem?.dayaListrik} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="450">450 VA</option>
                                    <option value="900">900 VA</option>
                                    <option value="1300">1300 VA</option>
                                    <option value="2200">2200 VA</option>
                                    <option value="3500">3500 VA</option>
                                  </Input>
                                  {errors.dayaListrik && <div className="error-message">{errors.dayaListrik}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="bantuanPerumahan">24. Bantuan Perumahan</Label>
                                  <Input type="select" name="bantuanPerumahan" id="bantuanPerumahan" value={selectedItem?.bantuanPerumahan} onChange={handleInputChange}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}>
                                    <option value="">Pilih</option>
                                    <option value="Pernah, >10 Tahun">Ya. &gt;10 Tahun</option>
                                    <option value="Pernah, <10 Tahun">Ya. &lt;10 Tahun</option>
                                    <option value="Tidak Pernah">Tidak Pernah</option>
                                  </Input>
                                  {errors.bantuanPerumahan && <div className="error-message">{errors.bantuanPerumahan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="modelRumah">25. Jenis Rumah</Label>
                                  <Input type="select" name="modelRumah" id="modelRumah" value={selectedItem?.modelRumah} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Permanen">Permanen</option>
                                    <option value="Semi Permanen">Semi Permanen</option>
                                    <option value="Panggung">Panggung</option>
                                  </Input>
                                  {errors.modelRumah && <div className="error-message">{errors.modelRumah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="pondasi">26. Pondasi</Label>
                                  <Input type="select" name="pondasi" id="pondasi" value={selectedItem?.pondasi} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.pondasi && <div className="error-message">{errors.pondasi}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="kolom">27. Kolom</Label>
                                  <Input type="select" name="kolom" id="kolom" value={selectedItem?.kolom} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.kolom && <div className="error-message">{errors.kolom}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="rangkaAtap">28. Rangka Atap</Label>
                                  <Input type="select" name="rangkaAtap" id="rangkaAtap" value={selectedItem?.rangkaAtap} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.rangkaAtap && <div className="error-message">{errors.rangkaAtap}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="plafon">29. Plafon</Label>
                                  <Input type="select" name="plafon" id="plafon" value={selectedItem?.plafon} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.plafon && <div className="error-message">{errors.plafon}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="balok">30. Balok</Label>
                                  <Input type="select" name="balok" id="balok" value={selectedItem?.balok} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.balok && <div className="error-message">{errors.balok}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="sloof">31. Sloof</Label>
                                  <Input type="select" name="sloof" id="sloof" value={selectedItem?.sloof} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.sloof && <div className="error-message">{errors.sloof}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="pintuJendelaKonsen">32. Pintu, Jendela, Konsen</Label>
                                  <Input type="select" name="pintuJendelaKonsen" id="pintuJendelaKonsen" value={selectedItem?.pintuJendelaKonsen} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.pintuJendelaKonsen && <div className="error-message">{errors.pintuJendelaKonsen}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="ventilasi">33. Ventilasi</Label>
                                  <Input type="select" name="ventilasi" id="ventilasi" value={selectedItem?.ventilasi} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.ventilasi && <div className="error-message">{errors.ventilasi}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="materialLantaiTerluas">34. Material Lantai Terluas</Label>
                                  <Input type="select" name="materialLantaiTerluas" id="materialLantaiTerluas" value={selectedItem?.materialLantaiTerluas} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Marmer/Granit">Marmer/Granit</option>
                                    <option value="Keramik">Keramik</option>
                                    <option value="Rabat ">Rabat </option>
                                    <option value="Papan Kayu">Papan Kayu</option>
                                    <option value="Bambu">Bambu</option>
                                    <option value="Tanah">Tanah</option>
                                    <option value="Lainnya">lainnya</option>
                                  </Input>
                                  {errors.materialLantaiTerluas && <div className="error-message">{errors.materialLantaiTerluas}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="kondisiLantai">35. Kondisi Lantai</Label>
                                  <Input type="select" name="kondisiLantai" id="kondisiLantai" value={selectedItem?.kondisiLantai} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.kondisiLantai && <div className="error-message">{errors.kondisiLantai}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="materialDindingTerluas">36. Material Dinding Terluas</Label>
                                  <Input type="select" name="materialDindingTerluas" id="materialDindingTerluas" value={selectedItem?.materialDindingTerluas} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Tembok Plesteran">Tembok Plesteran</option>
                                    <option value="Tembok Belum Plesteran">Tembok Belum Plesteran</option>
                                    <option value="Papan Kayu">Papan Kayu</option>
                                    <option value="Kalsiplank">Kalsiplank</option>
                                    <option value="Spandek">Spandek</option>
                                    <option value="Bedek/Anyaman Bambu">Bedek/Anyaman Bambu</option>
                                    <option value="Lainnya">Lainnya</option>
                                  </Input>
                                  {errors.materialDindingTerluas && <div className="error-message">{errors.materialDindingTerluas}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="kondisiDinding">37. Kondisi Dinding</Label>
                                  <Input type="select" name="kondisiDinding" id="kondisiDinding" value={selectedItem?.kondisiDinding} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.kondisiDinding && <div className="error-message">{errors.kondisiDinding}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="materialPenutupAtapTerluas">38. Material Penutup Atap Terluas</Label>
                                  <Input type="select" name="materialPenutupAtapTerluas" id="materialPenutupAtapTerluas" value={selectedItem?.materialPenutupAtapTerluas} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Genteng Kramik">Genteng Kramik</option>
                                    <option value="Genteng Biasa">Genteng Biasa</option>
                                    <option value="Multiroof">Multiroof</option>
                                    <option value="Spandek">Spandek</option>
                                    <option value="Seng">Seng</option>
                                    <option value="Asbes">Asbes</option>
                                    <option value="Daun-daunan">Daun-daunan</option>
                                    <option value="Lainnya">Lainnya</option>
                                  </Input>
                                  {errors.materialPenutupAtapTerluas && <div className="error-message">{errors.materialPenutupAtapTerluas}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="kondisiPenutupAtap">39. Kondisi Penutup Atap</Label>
                                  <Input type="select" name="kondisiPenutupAtap" id="kondisiPenutupAtap" value={selectedItem?.kondisiPenutupAtap} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Layak">Layak</option>
                                    <option value="Tidak Layak">Tidak Layak</option>
                                  </Input>
                                  {errors.kondisiPenutupAtap && <div className="error-message">{errors.kondisiPenutupAtap}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="luasRumah">40. Luas Rumah (m²)</Label>
                                  <Input type="number" name="luasRumah" id="luasRumah" value={selectedItem?.luasRumah} onChange={handleInputChange} className="input-center" />
                                  {errors.luasRumah && <div className="error-message">{errors.luasRumah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="luasTanah">41. Luas Tanah (m²)</Label>
                                  <Input type="number" name="luasTanah" id="luasTanah" value={selectedItem?.luasTanah} onChange={handleInputChange} className="input-center" 
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}/>
                                  {errors.luasTanah && <div className="error-message">{errors.luasTanah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="buanganAirLimbahRumahTangga">42. Buangan Air Limbah Rumah Tangga</Label>
                                  <Input type="select" name="buanganAirLimbahRumahTangga" id="buanganAirLimbahRumahTangga" value={selectedItem?.buanganAirLimbahRumahTangga}
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Jaringan Perpipaan">Jaringan Perpipaan</option>
                                    <option value="Diresapkan">Diresapkan</option>
                                    <option value="Buang Bebas">Buang Bebas</option>
                                  </Input>
                                  {errors.buanganAirLimbahRumahTangga && <div className="error-message">{errors.buanganAirLimbahRumahTangga}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="saranaPengelolaanLimbahCair">43. Sarana Pengelolaan Limbah Cair Rumah Tangga</Label>
                                  <Input type="select" name="saranaPengelolaanLimbahCair" id="saranaPengelolaanLimbahCair"
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} value={selectedItem?.saranaPengelolaanLimbahCair} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Berfungsi Baik">Berfungsi Baik</option>
                                    <option value="Tidak Berfungsi">Tidak Berfungsi</option>
                                    <option value="Tidak Tersedia">Tidak Tersedia</option>
                                  </Input>
                                  {errors.saranaPengelolaanLimbahCair && <div className="error-message">{errors.saranaPengelolaanLimbahCair}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="pemiliharaanSaranaPengelolaanLimbah">44. Pemeliharaan Sarana Pengelolaan Limbah Cair Rumah Tangga</Label>
                                  <Input type="select" name="pemiliharaanSaranaPengelolaanLimbah" id="pemiliharaanSaranaPengelolaanLimbah" 
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"}value={selectedItem?.pemiliharaanSaranaPengelolaanLimbah} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Terpelihara">Terpelihara</option>
                                    <option value="Tidak Terpelihara">Tidak Terpelihara</option>
                                  </Input>
                                  {errors.pemiliharaanSaranaPengelolaanLimbah && <div className="error-message">{errors.pemiliharaanSaranaPengelolaanLimbah}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="jenisTempatPembuanganAirTinja">45. Jenis Tempat Pembuangan Air Tinja</Label>
                                  <Input type="select" name="jenisTempatPembuanganAirTinja" id="jenisTempatPembuanganAirTinja" 
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} value={selectedItem?.jenisTempatPembuanganAirTinja} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Tangki Septik">Tangki Septik</option>
                                    <option value="Kolam/Sawah/Sungai">Kolam/Sawah/Sungai</option>
                                    <option value="Lubang Tanah">Lubang Tanah</option>
                                    <option value="Pantai/Tanah Lapangan/Kebun">Pantai/Tanah Lapangan/Kebun</option>
                                    <option value="IPAL">IPAL</option>
                                  </Input>
                                  {errors.jenisTempatPembuanganAirTinja && <div className="error-message">{errors.jenisTempatPembuanganAirTinja}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="kepemilikanKamarMandiDanJamban">46. Kepemilikan Kamar Mandi Dan Jamban</Label>
                                  <Input type="select" name="kepemilikanKamarMandiDanJamban" id="kepemilikanKamarMandiDanJamban" 
                                  disabled={selectedItem?.statusrumah === "Tidak Berpenghuni"} value={selectedItem?.kepemilikanKamarMandiDanJamban} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Sendiri">Sendiri</option>
                                    <option value="Bersama/MCK Komunal">Bersama/MCK Komunal</option>
                                    <option value="Tidak Ada">Tidak Ada</option>
                                  </Input>
                                  {errors.kepemilikanKamarMandiDanJamban && <div className="error-message">{errors.kepemilikanKamarMandiDanJamban}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="jumlahJamban">47. Jumlah Jamban</Label>
                                  <Input type="number" name="jumlahJamban" id="jumlahJamban" value={selectedItem?.jumlahJamban} 
                                  onChange={handleInputChange} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} className="input-center" />
                                  {errors.jumlahJamban && <div className="error-message">{errors.jumlahJamban}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="jenisKloset">48. Jenis Kloset</Label>
                                  <Input type="select" name="jenisKloset" id="jenisKloset" value={selectedItem?.jenisKloset} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Leher Angsa">Leher Angsa</option>
                                    <option value="Cubluk/Cemplung">Cubluk/Cemplung</option>
                                    <option value="Plengsengan">Plengsengan</option>
                                  </Input>
                                  {errors.jenisKloset && <div className="error-message">{errors.jenisKloset}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="jenisTangkiSeptik">49. Jenis Tangki Septik</Label>
                                  <Input type="select" name="jenisTangkiSeptik" id="jenisTangkiSeptik" value={selectedItem?.jenisTangkiSeptik} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Pabrikasi">Pabrikasi</option>
                                    <option value="Konvensional">Konvensional</option>
                                  </Input>
                                  {errors.jenisTangkiSeptik && <div className="error-message">{errors.jenisTangkiSeptik}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="materialTangkiSeptik">50. Material Tangki Septik</Label>
                                  <Input type="select" name="materialTangkiSeptik" id="materialTangkiSeptik" value={selectedItem?.materialTangkiSeptik} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Fiber">Fiber</option>
                                    <option value="Dinding Beton">Dinding Beton</option>
                                    <option value="Batu Bata">Batu Bata</option>
                                    <option value="Tanah">Tanah</option>
                                  </Input>
                                  {errors.materialTangkiSeptik && <div className="error-message">{errors.materialTangkiSeptik}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="alasTangkiSeptik">51. Alas Tangki Septik</Label>
                                  <Input type="select" name="alasTangkiSeptik" id="alasTangkiSeptik" value={selectedItem?.alasTangkiSeptik} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Kedap">Kedap</option>
                                    <option value="Tidak Kedap">Tidak Kedap</option>
                                  </Input>
                                  {errors.alasTangkiSeptik && <div className="error-message">{errors.alasTangkiSeptik}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="lubangPenyedotan">52. Lubang Penyedotan</Label>
                                  <Input type="select" name="lubangPenyedotan" id="lubangPenyedotan" value={selectedItem?.lubangPenyedotan} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Ada">Ada</option>
                                    <option value="Tidak Ada">Tidak Ada</option>
                                  </Input>
                                  {errors.lubangPenyedotan && <div className="error-message">{errors.lubangPenyedotan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="posisiTangkiSeptik">53. Posisi Tangki Septik</Label>
                                  <Input type="select" name="posisiTangkiSeptik" id="posisiTangkiSeptik" value={selectedItem?.posisiTangkiSeptik} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="Dalam Rumah">Dalam Rumah</option>
                                    <option value="Luar Rumah">Luar Rumah</option>
                                  </Input>
                                  {errors.posisiTangkiSeptik && <div className="error-message">{errors.posisiTangkiSeptik}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="jarakTangkiSeptikDenganSumberAir">54. Jarak Tangki Septik Dengan Sumber Air</Label>
                                  <Input type="select" name="jarakTangkiSeptikDenganSumberAir" id="jarakTangkiSeptikDenganSumberAir" value={selectedItem?.jarakTangkiSeptikDenganSumberAir} disabled ={selectedItem?.kepemilikanKamarMandiDanJamban === "Tidak Ada"} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="9">&lt; 10 meter</option>
                                    <option value="11">&gt; 10 meter</option>
                                  </Input>
                                  {errors.jarakTangkiSeptikDenganSumberAir && <div className="error-message">{errors.jarakTangkiSeptikDenganSumberAir}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="sumberAirMinum">55. Sumber Air Minum</Label>
                                  <Input type="select" name="sumberAirMinum" id="sumberAirMinum" value={selectedItem?.sumberAirMinum} onChange={handleInputChange}>
                                    <option value="">Pilih</option>
                                    <option value="PDAM">PDAM</option>
                                    <option value="SPAMDES">SPAMDES</option>
                                    <option value="Mata Air">Mata Air</option>
                                    <option value="Air Hujan">Air Hujan</option>
                                    <option value="Sumur/Sumur Bor">Sumur/Sumur Bor</option>
                                    <option value="Air Kemasan/Isi Ulang">Air Kemasan/Isi Ulang</option>
                                  </Input>
                                  {errors.sumberAirMinum && <div className="error-message">{errors.sumberAirMinum}</div>}
                                </FormGroup>
                               
                    
                                <FormGroup>
                                  <Label for="titikKoordinatRumah">56. Titik Koordinat Rumah</Label>
                                  <Input type="text" name="titikKoordinatRumah" id="titikKoordinatRumah" value={selectedItem?.titikKoordinatRumah || ""} onChange={handleInputChange} invalid={!!errors.titikKoordinatRumah} className="input-center" readOnly />
                                  <Button color="primary" onClick={handleGetCoordinates} className="btn-get-coordinates">
                                    <FaLocationArrow /> Ambil Koordinat
                                  </Button>
                                </FormGroup>
                    
                                <FormGroup>
                                  <Label for="manualTitikKoordinatRumah">Atau Masukkan Koordinat Manual</Label>
                                  <Input
                                    type="text"
                                    name="manualTitikKoordinatRumah"
                                    id="manualTitikKoordinatRumah"
                                    value={selectedItem?.manualTitikKoordinatRumah || ""}
                                    onChange={handleInputChange}
                                    invalid={!!errors.manualTitikKoordinatRumah}
                                    className="input-center"
                                    placeholder="Contoh: -8.512345, 117.012345"
                                  />
                                </FormGroup>

                                {/* Leaflet Satellite Map with Draggable Marker */}
                                <CoordinateMap
                                  coordinates={selectedItem?.titikKoordinatRumah || selectedItem?.manualTitikKoordinatRumah || ""}
                                  onCoordinateChange={handleMapCoordinateChange}
                                />
                    
                                <FormGroup>
                                  <Label for="tanggalPendataan">57. Tanggal Pendataan</Label>
                                  <Input type="date" name="tanggalPendataan" id="tanggalPendataan" value={selectedItem?.tanggalPendataan} onChange={handleInputChange} className="input-center" />
                                  {errors.tanggalPendataan && <div className="error-message">{errors.tanggalPendataan}</div>}
                                </FormGroup>
                                <FormGroup>
                                  <Label for="catatan">58. Catatan</Label>
                                  <Input type="text" name="catatan" id="catatan" value={selectedItem?.catatan} onChange={handleInputChange} className="input-center" />
                                  {errors.catatan && <div className="error-message">{errors.catatan}</div>}
                                </FormGroup>
                    
                                <FormGroup>
                                    <Label for="fotoRumah">Upload Foto Rumah</Label>
                                    
                                    {/* Input untuk unggah foto dari galeri */}
                                    <Input 
                                      type="file" 
                                      name="fotoRumah" 
                                      id="fotoRumah" 
                                      accept="image/*" 
                                      onChange={handlePhotoChange} 
                                    />
                  
                                    {/* Tombol untuk membuka kamera */}
                                    {isPreviewing ? (
                                      <div>
                                        <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
                                        <Button className="btn btn-primary mt-2" onClick={capturePhoto}>
                                          Ambil Foto
                                        </Button>
                                      </div>
                                    ) : (
                                      <Button className="btn btn-secondary mt-2" onClick={startPreview}>
                                        Gunakan Kamera
                                      </Button>
                                    )}
                  
                                    {/* Preview gambar yang diunggah atau ditangkap */}
                                    {imagePreview && (
                                      <div className="mt-3">
                                        <img src={imagePreview} alt="Preview" style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }} />
                                        <Button className="btn btn-danger mt-2" onClick={cancelPreview}>
                                          Hapus Foto
                                        </Button>
                                      </div>
                                    )}
                                  </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleFormSubmit}>Simpan</Button>{' '}
        <Button color="secondary" onClick={toggle}>Batal</Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditModal;